/**
 * Base 8 Spacing - https://www.figma.com/file/K06fZcdLGvISgysbawuP4M/White-Label-Colors---WIP?node-id=181%3A1413
 * XS: 4, S: 8, M: 12, L: 16, XL: 24, X2L: 32, X3L: 40, X4L: 48, X5L: 64, X6L: 80,
 */
export var SPACINGS = {
  XS: 4,
  S: 8,
  M: 12,
  L: 16,
  XL: 24,
  X2L: 32,
  X3L: 40,
  X4L: 48,
  X5L: 64,
  X6L: 80
};